import { isResource } from '@medplum/core'
import type {
  Coding,
  Communication,
  Composition,
  Reference,
} from '@medplum/fhirtypes'
import { ELATION_VISIT_NOTE_TRANSCRIPT_SYSTEM } from '#src/codeSystems.ts'
import { Tag as TagDecorator } from '#src/decorators.ts'
import { ExtendedCommunication } from '#src/models/communications/ExtendedCommunication.ts'
import { hasTag } from '#src/tags.ts'
import { isOfType } from '#src/utils.ts'

export class VisitNoteTranscript extends ExtendedCommunication {
  static isInstance(value: unknown): value is Communication {
    return (
      isResource(value) &&
      isOfType(value, 'Communication') &&
      hasTag(value, { system: ELATION_VISIT_NOTE_TRANSCRIPT_SYSTEM })
    )
  }

  get composition(): Reference<Composition> | undefined {
    return this.resource.basedOn?.find((reference) =>
      isOfType(reference, 'Composition')
    )
  }

  set composition(value: Reference<Composition> | undefined) {
    const basedOn = (this.resource.basedOn ?? []).filter((ref) =>
      isOfType(ref, 'Composition')
    )
    if (value) {
      basedOn.push(value)
    }
    this.resource.basedOn = basedOn
  }

  @TagDecorator({
    system: ELATION_VISIT_NOTE_TRANSCRIPT_SYSTEM,
  })
  elationVisitNoteId?: Coding
}
